// TODO - Type 'any' needs to be fixed.
import Dialog from "@mui/material/Dialog";
import isPast from "date-fns/isPast";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import DialogWrapper from "../../../../../design/dialog-wrapper";
import NewShiftDialogForm, { CoverageStep } from "./new-shift-dialog-form";
import PastShiftDialog from "./past-shift";

type NewShiftDialogProps = {
	handleClose: (() => void) | undefined;
	open: boolean;
	draftShiftDate: Date;
	isShiftSwap?: boolean;
	requestComponent?: any;
	isShiftCoverage?: boolean;
};

const NewShiftDialog: React.FC<NewShiftDialogProps> = ({
	handleClose,
	open,
	draftShiftDate,
	isShiftSwap,
	requestComponent,
	isShiftCoverage,
}) => {
	const { t } = useTranslation();
	// The Assign Workers step and its results bring their own heading and use
	// the same width as the Publish dialog's picker
	const [coverageStep, setCoverageStep] = useState<CoverageStep>("form");
	const isFormStep = coverageStep === "form";
	return (
		<Dialog
			onClose={(event, reason) => {
				if (reason !== "backdropClick" && handleClose) {
					handleClose();
				}
			}}
			aria-labelledby='add-new-shift'
			open={open}
			PaperProps={{ sx: { maxWidth: isFormStep ? "900px" : "1250px" } }}
			fullWidth
		>
				<DialogWrapper dialogTitle={isShiftSwap ? t("scheduler_worker-request") : t("scheduler_create-shift")}
					hideTitle={!isFormStep}
					contentStyles={{ padding: "0", overflow: isFormStep ? "hidden" : "auto" }}
					dialogContent={
						<NewShiftDialogForm
							draftShiftDate={draftShiftDate}
							handleClose={handleClose}
							isShiftSwap={isShiftSwap}
							requestComponent={requestComponent}
							isShiftCoverage={isShiftCoverage}
							onCoverageStepChange={setCoverageStep}
						/>
					}
				/>
		</Dialog>
	);
};

export default NewShiftDialog;
